import { render, staticRenderFns } from "./onlineDepositStatus.vue?vue&type=template&id=18dd62f5&scoped=true"
import script from "./onlineDepositStatus.vue?vue&type=script&lang=js"
export * from "./onlineDepositStatus.vue?vue&type=script&lang=js"
import style0 from "./onlineDepositStatus.vue?vue&type=style&index=0&id=18dd62f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dd62f5",
  null
  
)

export default component.exports